import axios from "axios";
import Form from "@JohnLewisPartnership/checkout-forms/dist/components/form-simple/Form";
import { useRouter } from "next/router";
import React, { useState } from "react";
import { dispatchNewEvent } from "@/utils/analytics/trigger/analyticsTrigger";
import styles from "./email-form.module.scss";
import useAttachments from "./useAttachments";
import { getEscalatedFormElements } from "./utils";

function EscalateEmailForm({
  subject,
  shop = null,
  fields,
  imageMessage = "",
  onSubmitted = () => {},
  id = "",
  source,
  submitButton,
}) {
  const router = useRouter();
  const orderId = router.query?.orderId || "";
  const [submitting, setSubmitting] = useState(false);
  const [serverError, setServerError] = useState(null);
  const { attachments, attachmentError, handleAttachmentAdded, handleAttachmentRemoved } = useAttachments();
  const [intialData] = useState({
    loading: false, // typeof window !== "undefined" && !!window.auth0,
    data: { orderNumber: orderId },
  });

  const handleSubmit = (data, onComplete) => {
    // Hack as we are using form fields to display steps. Each step component has undefined has the id/name
    const clonedData = { ...data };
    delete clonedData.undefined;
    clonedData.webFormSubject = subject;
    if (shop) {
      clonedData.purchaseLocation = shop;
    }
    clonedData.imageUpload = undefined;
    if (source) clonedData.source = source;
    const formData = new FormData();
    formData.append("caseData", JSON.stringify(clonedData));
    attachments.forEach(attachment => formData.append("file", attachment.file));

    setSubmitting(!!attachments.length);
    axios
      .post(`${process.env.NEXT_PUBLIC_API_DOMAIN}/customer-help/email-us/v1/escalated-case`, formData)
      .then(response => {
        onSubmitted(
          response.data.caseNumber,
          clonedData.emailAddress,
          clonedData.webFormSubject,
          shop,
          response.data.warnings && response.data.warnings.length > 0,
        );
        dispatchNewEvent("dataStateChange", {
          action: "email.submit",
          type: "success",
          topic: subject,
          imageUpload: attachments.length > 0, // false depending whether an image was uploaded with the email or not.
        });
        setSubmitting(false);
        onComplete();
      })
      .catch(error => {
        let body;
        let title = "Sorry, your email wasn't sent.";
        if (error.response) {
          // Server side issue
          body = "We've had a technical problem. Please try again later.";
        } else if (error.request) {
          // Connectivity / Timeout
          title = "Sorry, we've lost connection.";
          body = "Please try submitting the form again";
        } else {
          // Something happened in setting up the request that triggered an Error
          body = "There's been a technical problem. Please try again later.";
        }
        dispatchNewEvent("dataStateChange", {
          action: "email.submit",
          type: "failure",
          topic: subject,
          errorMessage: error.response.data.messages && error.response.data.messages.join("|"),
          errorCode: error.response.data.code,
        });

        setServerError({ title, body });
        setSubmitting(false);
        onComplete();
      });
  };

  const elements = getEscalatedFormElements(fields, shop, {
    handleAttachmentAdded,
    handleAttachmentRemoved,
    attachmentError,
    attachments,
    imageMessage,
  });

  return (
    <div className={styles.escalationEmailformWrapper}>
      <Form
        fields={elements}
        initialValues={intialData.data}
        onSubmit={handleSubmit}
        serverError={serverError}
        key={id}
        submitButton={submitButton}
        id="escalate-email-form"
      />
      {submitting ? (
        <p className={styles["email-form__submit-message"]}>
          Sending your email. If you&apos;ve attached large images, it may take a little while.
        </p>
      ) : null}
    </div>
  );
}

export default EscalateEmailForm;
